import { NETLIFY_URL } from "../internal-api/commerce/constants"
import { useNetwork, Method } from "../internal-api/network/use-network.hook"

export interface ResponseAttributes {
  status: number
  message: string
}

const config = {
  baseURL: NETLIFY_URL,
}

const useCustomFetch = <T,>(url: string) => {
  const [{ data, loading, error }, fetch] = useNetwork<
    ResponseAttributes,
    { message: string }
  >({ url, method: Method.Post }, config)

  const subscribe = async (data: T) => {
    await fetch({ data })
  }

  return {
    data,
    loading,
    error,
    subscribe,
  }
}

export default useCustomFetch
